import links from '../data/scholarLinks';
import { motion } from 'framer-motion';

// Konteyner animasyonu (Çocukları tetikler)
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1 // Her eleman arasında 0.1sn bekle
    }
  }
};

// Çocuk animasyonu (Alttan yukarı çıkar)
const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { type: "spring", stiffness: 100 }
  }
};

export default function ScholarLinks() {
  return (
    <motion.div 
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-50px" }}
      className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4"
    >
      {links.map((item) => (
        <motion.a
          key={item.name}
          variants={itemVariants}
          href={item.url}
          className="card flex items-center gap-4 p-5 text-navy hover:bg-blue-50 group bg-white rounded-lg shadow-sm border border-gray-100"
          target="_blank"
          rel="noopener noreferrer"
          whileHover={{ scale: 1.02, transition: { duration: 0.2 } }}
          whileTap={{ scale: 0.98 }}
        >
          <span className="text-2xl group-hover:scale-110 transition-transform duration-200">{item.icon}</span>
          <span className="font-medium group-hover:underline">{item.name}</span>
          <motion.svg 
            className="w-5 h-5 ml-auto" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
            initial={{ opacity: 0, x: -10 }}
            whileHover={{ opacity: 1, x: 0 }}
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
          </motion.svg>
        </motion.a>
      ))}
    </motion.div>
  );
}